import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Section } from "@/components/layout/section";

const FAQS = [
  {
    q: "Apakah Ronda Malam menggantikan petugas keamanan?",
    a: "Tidak. Ronda Malam adalah alat bantu yang menghubungkan warga, ketua RT/RW, dan petugas existing agar koordinasi lebih cepat dan tercatat.",
  },
  {
    q: "Bagaimana dengan privasi dan keamanan data?",
    a: "Seluruh data dienkripsi dan hanya pihak berwenang yang dapat mengakses laporan sesuai kebijakan akses yang berlaku.",
  },
  {
    q: "Di mana saja layanan ini tersedia?",
    a: "Saat ini kami membuka pendaftaran awal (early access). Kami akan menghubungi Anda untuk wilayah operasional terdekat.",
  },
  {
    q: "Berapa biayanya?",
    a: "Tahap pengenalan bebas biaya untuk komunitas percontohan. Kami akan mengumumkan paket resmi menjelang peluncuran.",
  },
];

export function FAQ() {
  return (
    <Section id="faq">
      <div className="mx-auto max-w-2xl">
        <h2 className="text-center text-3xl font-bold sm:text-4xl">
          Pertanyaan yang Sering Diajukan
        </h2>
        <Accordion type="single" collapsible className="mt-10">
          {FAQS.map((item, index) => (
            <AccordionItem key={index} value={`item-${index}`}>
              <AccordionTrigger>{item.q}</AccordionTrigger>
              <AccordionContent>{item.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </Section>
  );
}
